// This icon file is generated automatically.
var PtoAppStoreFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M27 4.5h-9.5a.5.5 0 00-.5.5v9.5c0 .28.23.5.5.5H27a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5zM27 17h-9.5a.5.5 0 00-.5.5V27c0 .27.23.5.5.5H27a.5.5 0 00.5-.5v-9.5a.5.5 0 00-.5-.5zM14.5 4.5H5a.5.5 0 00-.5.5v9.5c0 .28.22.5.5.5h9.5a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5zm0 12.5H5a.5.5 0 00-.5.5V27c0 .27.22.5.5.5h9.5a.5.5 0 00.5-.5v-9.5a.5.5 0 00-.5-.5z", "fill-rule": "nonzero" } }] }, "name": "pto-app-store", "theme": "filled" };
export default PtoAppStoreFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoAppStoreFilled.js
// module id = 3862
// module chunks = 0